<placeme-layout-seo [seo]="'teamsPage.seo' | translate">
  <placeme-jumbotron [seo]="'teamsPage.seo' | translate"></placeme-jumbotron>
  <section class="main-content">
    <markdown class="page-markdown" [data]="'teamsPage.teams.content' | translate"></markdown>
    <div class="cards">
      <placeme-team-card [team]="team" *ngFor="let team of 'teamsPage.teams.teams' | translate"></placeme-team-card>
    </div>
  </section>
</placeme-layout-seo>
